import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, AlertTriangle } from 'lucide-react';
import { accountApi } from '../../api/accountApi';

export function DeleteAccount() {
  const nav = useNavigate();
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ['account'], queryFn: () => accountApi.getState() });
  const [agree, setAgree] = useState(false);
  const [confirming, setConfirming] = useState(false);

  const del = useMutation({
    mutationFn: () => accountApi.deleteAccount(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['account'] });
      nav('/');
    },
  });

  const categories = data?.data_categories ?? [];
  const retention = data?.retention_days ?? 7;

  return (
    <div className="rf-detail">
      <div className="rf-topbar">
        <button className="rf-back" onClick={() => nav(-1)}><ChevronLeft /> Назад</button>
        <div className="rf-topbar-title">Удаление аккаунта</div>
      </div>

      <div className="rf-detail-scroll">
        <div
          className="rf-card"
          style={{ padding: 16, border: '1px solid var(--status-error, #ff6b6b)', background: 'rgba(255,107,107,0.06)' }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, color: 'var(--status-error, #ff6b6b)' }}>
            <AlertTriangle size={22} />
            <b style={{ fontSize: 16 }}>Опасная зона</b>
          </div>
          <p style={{ lineHeight: 1.55, fontSize: 14.5, margin: '0 0 12px' }}>
            Будут удалены аккаунт и <b>все связанные данные</b>:
          </p>
          <ul style={{ margin: '0 0 14px', paddingLeft: 20 }}>
            {categories.map((c) => (
              <li key={c} style={{ marginBottom: 5, lineHeight: 1.5 }}>{c}</li>
            ))}
          </ul>
          <div style={{ background: 'var(--rf-surface, rgba(255,255,255,0.06))', borderRadius: 10, padding: '10px 14px', fontSize: 13.5, lineHeight: 1.5, marginBottom: 16 }}>
            После удаления данные хранятся ещё <b>{retention} дн.</b>, затем стираются безвозвратно.
            Если вы вернётесь в течение этого срока, можно будет восстановить данные или начать заново.
          </div>

          <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer', fontSize: 14, marginBottom: 16 }}>
            <input type="checkbox" checked={agree} onChange={(e) => { setAgree(e.target.checked); setConfirming(false); }} style={{ marginTop: 3 }} />
            <span>Я понимаю, что аккаунт и все данные будут удалены.</span>
          </label>

          {!confirming ? (
            <button
              disabled={!agree}
              onClick={() => setConfirming(true)}
              style={{ width: '100%', padding: '15px', borderRadius: 12, border: 'none', fontSize: 16, fontWeight: 600, cursor: agree ? 'pointer' : 'not-allowed', background: 'var(--status-error, #ff6b6b)', color: '#fff', opacity: agree ? 1 : 0.5 }}
            >
              Удалить аккаунт
            </button>
          ) : (
            <>
              <div style={{ textAlign: 'center', fontSize: 14, marginBottom: 10 }}>Точно удалить аккаунт?</div>
              <button
                disabled={del.isPending}
                onClick={() => del.mutate()}
                style={{ width: '100%', padding: '15px', borderRadius: 12, border: 'none', fontSize: 16, fontWeight: 700, cursor: 'pointer', background: 'var(--status-error, #ff6b6b)', color: '#fff' }}
              >
                {del.isPending ? 'Удаление…' : 'Да, удалить безвозвратно'}
              </button>
              <button
                disabled={del.isPending}
                onClick={() => setConfirming(false)}
                style={{ width: '100%', padding: '13px', borderRadius: 12, marginTop: 10, border: '1px solid var(--border-subtle, rgba(255,255,255,0.14))', background: 'transparent', color: 'var(--text-primary, #e8ecf4)', fontSize: 15, cursor: 'pointer' }}
              >
                Отмена
              </button>
            </>
          )}

          {del.isError && <div style={{ color: 'var(--status-error, #ff6b6b)', fontSize: 14, marginTop: 12 }}>Не удалось удалить. Попробуйте ещё раз.</div>}
        </div>
      </div>
    </div>
  );
}

export default DeleteAccount;
